<!-- Hidden file input - always available -->
<input
  #fileInput
  type="file"
  multiple
  style="display:none;"
  (change)="fileInputChangedEvent($event)"
  [accept]="acceptString()"/>

@if (headline()) {
  <div class="mt-2 basis-full flex flex-row items-center h-[3rem] rounded-t-md">
    <div class="grow text-[1.125rem] font-medium">
      {{headline()}} <!-- ({{files().length}}) -->
    </div>
    @if (uploadProgress(); as progress) {
      <div class="text-sm text-gray-500 mr-2">{{progress.current}}/{{progress.total}} {{uploadedText}}</div>
    }
    @if (files().length > 0 && canUpload()) {
      <nx-default-button
        [style]="'dark'"
        (click)="fileInput.click()"
        [tooltip]="uploadText"
        [icon]="'icon-plus'">
      </nx-default-button>
    }
  </div>
}
@if (files().length === 0) {
  <div 
    class="text-base border border-dashed rounded-md min-h-[74px] flex flex-col items-center justify-center transition-colors"
    [class.cursor-pointer]="canUpload()"
    [class.border-gray-300]="!isDragging() && !dropError()"
    [class.text-gray-400]="!isDragging() && !dropError()"
    [class.border-blue-400]="isDragging()"
    [class.bg-blue-50]="isDragging()"
    [class.text-blue-500]="isDragging()"
    [class.border-red-400]="dropError()"
    [class.bg-red-50]="dropError()"
    [class.text-red-500]="dropError()"
    (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave($event)"
    (drop)="onDrop($event)"
    (click)="canUpload() && fileInput.click()">
    @if (dropError(); as error) {
      <span>{{error}}</span>
    } @else if (isDragging()) {
      {{dropHereText}}
    } @else {
      @if (canUpload()) {
        <i class="text-[32px]" [ngClass]="'icon-document-upload'"></i>
      }
      <span class="mt-[-6px] mb-[10px]">{{emptyMessage()}}</span>
    }
  </div>
} @else {
  <div 
    class="relative group rounded-md transition-colors"
    [class.ring-2]="isDragging() || dropError()"
    [class.ring-blue-400]="isDragging()"
    [class.bg-blue-50]="isDragging()"
    [class.ring-red-400]="dropError()"
    [class.bg-red-50]="dropError()"
    (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave($event)"
    (drop)="onDrop($event)">
    
    @if (dropError(); as error) {
      <div class="absolute inset-0 flex items-center justify-center bg-red-50/80 rounded-md z-20">
        <span class="text-red-500 text-sm font-medium">{{error}}</span>
      </div>
    }
    
    <app-file-gallery-display
      [files]="files()"
      [showDeleteButton]="canDelete()"
      [emptyMessage]="emptyMessage() || ''"
      (deleteFileEvent)="deleteFile($event)">
    </app-file-gallery-display>
  </div>
}



